module.exports = __webpack_public_path__ + "img/logistica.69db59aa.png";